export default __webpack_public_path__ + "static/media/Kristina_Musatova.d0f75028.png";